import $ from 'jquery';

export default function singleVideoHero() {
  $('.single-video-hero').each(function () {
    const $section = $(this);
    const $bg = $section.find('.single-video-hero__bg.has-video').first();
    const $playBtn = $section.find('.single-video-hero__play').first();
    const $image = $section.find('.single-video-hero__image').first();

    $section.addClass('is-enhanced');

    function startEmbeddedMedia() {
      if (!$bg.length) {
        return;
      }

      const $videoContainer = $bg.find('.single-video-hero__video-container');
      const $htmlVideo = $videoContainer.find('video');
      const $iframe = $videoContainer.find('iframe');

      if ($htmlVideo.length) {
        $htmlVideo.each(function () {
          this.muted = true;
          const playPromise = this.play();

          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        });
      }

      if ($iframe.length) {
        $iframe.each(function () {
          const $this = $(this);
          const src = $this.attr('src');

          if (src) {
            $this.attr('src', src);
          }
        });
      }
    }

    function playHeroVideo(e) {
      e.preventDefault();

      if (!$bg.length || $bg.hasClass('is-playing')) {
        return;
      }

      $bg.addClass('is-playing');
      $section.addClass('is-video-active');
      startEmbeddedMedia();
    }

    if ($playBtn.length) {
      $playBtn.on('click', playHeroVideo);

      $playBtn.on('mouseenter', function () {
        $section.addClass('is-hovering-play');
      });

      $playBtn.on('mouseleave', function () {
        $section.removeClass('is-hovering-play');
      });
    }

    if ($image.length) {
      $section.on('mousemove', function (e) {
        if ($bg.hasClass('is-playing')) {
          return;
        }

        const offsetX = (e.pageX - $section.offset().left) / $section.outerWidth() - 0.5;
        const offsetY = (e.pageY - $section.offset().top) / $section.outerHeight() - 0.5;

        $image.css('transform', `scale(1.03) translate(${offsetX * 10}px, ${offsetY * 10}px)`);
      });

      $section.on('mouseleave', function () {
        if ($bg.hasClass('is-playing')) {
          return;
        }

        $image.css('transform', 'scale(1)');
      });
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              $section.addClass('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.2,
        }
      );

      observer.observe($section[0]);
    } else {
      $section.addClass('is-visible');
    }
  });
}